import { Injectable } from '@angular/core';
import { HttpService, ErrorService } from 'src/app/utils/services';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { map,catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VendorsService {

  private searchStatus = new BehaviorSubject<any>({});
  public currentSelectedTab = '';
  constructor(private httpService: HttpService,
    private errService: ErrorService) { }

  /**
  * @method - to get the data
  * @param url - api name
  * @param data - login credentials
  */
  get(url: any, isFM200Service?: boolean, isSdk?: boolean): Observable<any> {
    return this.httpService.get(url, isFM200Service, isSdk).pipe(
      map((res: Response) => {
        return (res.hasOwnProperty('body') ? res.body : res);
      }),
      catchError(error => {
        this.errorHandler(error);
        return throwError(error.hasOwnProperty('error') ? error.error : error);
      })
    );
  }

  /**
   * @method - to send the data
   * @param url - api name
   * @param data - login credentials
   */
  post(url: any, data: any): Observable<any> {
    return this.httpService.post(url, data).pipe(
      map((res: Response) => {
        return (res.hasOwnProperty('body') ? res.body : res);
      }),
      catchError(error => {
        this.errorHandler(error);
        return throwError(error.hasOwnProperty('error') ? error.error : error);
      })
    );
  }

  /**
   * @method - to update the data
   * @param url
   * @param data
   */
  put(url: any, data: any): Observable<any> {
    return this.httpService.put(url, data).pipe(
      map((res: Response) => {
        return (res.hasOwnProperty('body') ? res.body : res);
      }),
      catchError(error => {
        this.errorHandler(error);
        return throwError(error.hasOwnProperty('error') ? error.error : error);
      })
    );
  }

  /**
  * @method - to get the data
  * @param url - api name
  * @param data - login credentials
  */
  fileDownload(url: any, data: any): Observable<any> {
    return this.httpService.fileDataDownload(url, data).pipe(
      map((res: Response) => {
        return (res.hasOwnProperty('body') ? res.body : res);
      }),
      catchError(error => {
        this.errorHandler(error);
        return throwError(error.hasOwnProperty('error') ? error.error : error);
      })
    );
  }

  /**
   * @method - to update the data
   * @param url
   * @param data
   */
  delete(url: any): Observable<any> {
    return this.httpService.delete(url).pipe(
      map((res: Response) => {
        return (res.hasOwnProperty('body') ? res.body : res);
      }),
      catchError(error => {
        this.errorHandler(error);
        return throwError(error.hasOwnProperty('error') ? error.error : error);
      })
    );
  }

  upload(url: any, data: any): Observable<any> {
    return this.httpService.postFile(url, data).pipe(
      map((res: Response) => {
        return (res.hasOwnProperty('body') ? res.body : res);
      }),
      catchError(error => {
        this.errorHandler(error);
        return throwError(error.hasOwnProperty('error') ? error.error : error);
      }));
  }
  createUsers(url: any, data: any): Observable<any> {
    return this
      .httpService
      .postApi(url, data).pipe(
      map((res: Response) =>{
        return (res.hasOwnProperty('body') ? res.body : res);
    //  res.json()
      }),
      catchError(err=>{
        return throwError(err)
      })
      );
  }
  handleError(error: any): Observable<any> {
    return throwError(error);
  }
  downloadCSV(url) {
    return this.httpService.fileDownload(url).pipe(map((res: Response) => res),
      catchError(error => {
        this.errorHandler(error);
        return throwError(error.json())
      }));
  }

  downloadDataCSV(url, data) {
    return this.httpService.fileDataDownload(url, data).pipe(map((res: Response) => res),
      catchError(error => {
        this.errorHandler(error);
        return throwError(error)
      }));
  }

  errorHandler(error: any) {
    this.errService.handleError(error);
  }
  getSubscription(subsName) {
    let subscription: any;
    switch (subsName) {
      case 'search':
        subscription = this.searchStatus.asObservable();
        break;   
    }
    return subscription;
  }

  setSubscription(subsName, data) {
    switch (subsName) {
      case 'search':
        this.searchStatus.next(data);
        break;   
    }
  }

}
